import { RestorePasswordPage } from '@ppay/client'
import React from 'react'

import { routes } from '../../router'

export function Page() {
  return <RestorePasswordPage successPath={routes.auth.login} />
}
